module.exports = __webpack_public_path__ + "img/logo.c395c1e5.png";